"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.topUpValidationSchema = void 0;
const yup_1 = require("yup");
const mui_inputs_asset_1 = require("@dzambalaorg/mui-inputs-asset");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
exports.topUpValidationSchema = (0, yup_1.object)().shape({
    token: mui_inputs_asset_1.tokenAssetValidationSchema,
    address: yup_rules_eth_1.addressValidationSchema,
});
//# sourceMappingURL=validation.js.map